var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOktaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.654 24.5827C29.0529 24.5827 27.9209 23.3375 27.9209 21.7041C27.9209 20.0707 29.0529 18.8256 30.654 18.8256C32.2551 18.8256 33.3549 20.0707 33.3549 21.7041C33.3549 23.3375 32.239 24.5827 30.654 24.5827ZM30.3953 26.2969C31.6891 26.2969 32.7888 25.7955 33.4841 24.7442C33.6134 25.7632 34.3574 26.135 35.2953 26.135H36.0393V24.5178H35.7159C35.1822 24.5178 35.0529 24.259 35.0529 23.6607V17.2726H33.3387V18.5827C32.7565 17.6609 31.6568 17.1111 30.3955 17.1111C28.1476 17.1111 26.0777 18.9871 26.0777 21.7038C26.0777 24.4205 28.1473 26.2969 30.3953 26.2969ZM21.5655 24.0813C21.5655 25.5367 22.471 26.135 23.5546 26.135H25.6407V24.5178H24.1206C23.49 24.5178 23.3604 24.2751 23.3604 23.6607V18.8899H25.6407V17.2726H23.3604V14.2969H21.5655V24.0813ZM13.3986 26.135H15.1936V22.3348H15.7919L18.8485 26.135H21.1125L17.215 21.3158L20.207 17.2729H18.1855L15.7435 20.6852H15.1936V14.2974H13.3986V26.135ZM7.5766 17.1111C5.06992 17.1111 3 18.9871 3 21.7038C3 24.4205 5.06992 26.2966 7.5766 26.2966C10.0833 26.2966 12.1532 24.4205 12.1532 21.7038C12.1532 18.9871 10.0833 17.1111 7.5766 17.1111ZM7.5766 24.5827C5.97548 24.5827 4.84345 23.3375 4.84345 21.7041C4.84345 20.0707 5.97548 18.8256 7.5766 18.8256C9.17772 18.8256 10.3098 20.0707 10.3098 21.7041C10.3098 23.3375 9.17772 24.5827 7.5766 24.5827Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOktaLogo);
export default __webpack_public_path__ + "static/media/okta-logo.4ef3a2d3468d1a312f86b5e3ca72d1e4.svg";
export { ForwardRef as ReactComponent };